import { Controller, type UseFormReturn } from "react-hook-form";

import { MultipleImageFieldNew } from "@/components/ui/form/fields-new/image-field/multiple";
import { InputTextFieldNew } from "@/components/ui/form/fields-new/input-field/input-text";
import { TextAreaFieldNew } from "@/components/ui/form/fields-new/text-area-field";
import { Label } from "@/components/ui/label/label";

import type { ContactUpdateInputZodSchemaType } from "../../../../schema";

type Props = {
	form: UseFormReturn<ContactUpdateInputZodSchemaType>;
};

export const FormFields = ({ form }: Props) => {
	const {
		register,
		formState: { errors },
		control,
	} = form;

	return (
		<div className="space-y-12">
			<TextAreaFieldNew
				label={
					<div className="flex items-center gap-x-2">
						<p>問い合わせ内容</p>
						<Label size="sm" text="必須" />
					</div>
				}
				placeholder="(例)添い寝の場合でもご宿泊料金として、おひとり様1000円の追加料金を設定したいのですが、設定方法を教えていただけますか？"
				errorMessage={
					typeof errors.message?.message === "string"
						? errors.message?.message
						: errors.message?.message?.message
				}
				{...register("message.message")}
			/>
			<InputTextFieldNew
				label={
					<div className="space-y-1">
						<p>関連URL</p>
						<p className="text-xs text-zinc-500">該当するページのURLがございましたらご記入ください</p>
					</div>
				}
				placeholder="(例)https://admin.chillnn.com/17a33622a636d/items/plan/edit/17f16f89250211"
				errorMessage={errors.message?.relatedURLs?.[0]?.message}
				{...register("message.relatedURLs.0")}
			/>
			<Controller
				name={"message.images"}
				control={control}
				render={({ field }) => {
					return (
						<MultipleImageFieldNew
							label={
								<div className="space-y-1">
									<p>画像</p>
									<p className="text-xs text-brand">迅速にサポートさせていただくため、該当画面のスクリーンショットをご添付ください。</p>
								</div>
							}
							images={field.value}
							onSetKeyVisuals={field.onChange}
							ownerID={""}
							resourceID={""}
							errorMessage={errors.message?.images?.message}
						/>
					);
				}}
			/>
		</div>
	);
};

FormFields.displayName = "FormFields";
